import React, {useState, useEffect, useContext} from 'react';
import {useHistory, Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';

import {Button} from '@components';
import useStore from '@context/useStore';
import {searchUsers} from '@apis';
import {ReactComponent as Search} from '@images/search.svg';
import {resolveValue} from 'react-hot-toast';
import axios from 'axios';
import {SearchContext} from '@context/searchContext';
import {API_HOST} from '@apis/';

const ContentWrapper = ({
  children,
  breadcrumb,
  hasSearch = true,
  addProduct = null,
  removeShopUser = null,
  productDetail = null,
  onButtonOneClick,
  onButtonTwoClick,
  onButtonThreeClick,
  isEditedView = false,
  searchfield,
}) => {
  const {storeDetails} = useStore();
  const history = useHistory();
  const {t} = useTranslation();

  // useEffect(async ()=>{
  //   if(hasSearch){
  //   // data = await searchUsers()
  //   // setUsers(data)
  //   }
  // },[])

  const {userResults, setUserResults, loading, setLoading} = useContext(
    SearchContext,
  );

  const searchFunction = async e => {
    const data = await searchUsers(e.target.value);
    setUserResults(data.results);
  };

  const showBreadcrum = () => {
    if (Array.isArray(breadcrumb)) {
      return (
        <p className="text-xs text-menu-title">
          {breadcrumb.map((item, index) => {
            const isLast = index === breadcrumb.length - 1;

            if (isLast) {
              return <span key={index}>{item.title}</span>;
            }

            return (
              <React.Fragment key={index}>
                <Link
                  to={item.link}
                  className="tabbed-link hover:text-red transition-colors duration-200">
                  {item.title}
                </Link>
                {' / '}
              </React.Fragment>
            );
          })}
        </p>
      );
    }

    // Fallback for string breadcrumb (should be deprecated)
    return <p className="text-xs text-menu-title">{breadcrumb}</p>;
  };

  return (
    <>
      <div className="hidden lg:flex w-full pr-6 items-center px-8">
        <div className="flex flex-col justify-center">
          <div className="flex flex-row">
            <p className="text-md w-max font-semibold pb-4">
              {storeDetails?.name || t('layout.storeNameNotSetup')}
            </p>
            {!storeDetails?.name && (
              <Button
                type="link"
                label={t('layout.setupNow')}
                onClick={() => history.push('/store-setup')}
              />
            )}
          </div>
          {showBreadcrum()}
        </div>
        <div className="ml-auto flex flex-row items-center">
          {addProduct ? (
            <Button
              onClick={() => onButtonOneClick()}
              label={t('layout.addProduct')}
              type="primary"
              style={{width: '115px'}}
            />
          ) : hasSearch ? (
            <div className="relative w-full">
              {/* <input
                className="border border-gray-100 focus:outline-none focus:border-indigo-700 rounded w-full text-sm text-gray-500 bg-gray-100 pl-12 py-2"
                type="text"
                placeholder={t('layout.searchUser')}
                onChange={e => searchFunction(e)}
              />
              <div className="text-gray-500 absolute ml-4 top-0 bottom-0 right-6 m-auto w-4 h-4">
                <Search height={18} />
              </div> */}
            </div>
          ) : !removeShopUser ? (
            !productDetail ? (
              <>
                <Button
                  onClick={() => onButtonOneClick()}
                  label={t('layout.saveChanges')}
                  type="primary"
                  disabled={!isEditedView}
                  style={{width: '115px'}}
                />
                <Button
                  onClick={() => onButtonTwoClick()}
                  label={t('layout.cancel')}
                  type="secondary"
                  disabled={!isEditedView}
                  style={{width: '115px'}}
                />
              </>
            ) : (
              <Button
                onClick={() => onButtonThreeClick()}
                label={t('layout.removeProduct')}
                type="error"
                style={{width: '115px'}}
              />
            )
          ) : (
            <>
              <Button
                onClick={() => onButtonTwoClick()}
                label={t('layout.addMoneySpent')}
                type="primary"
                style={{width: '115px'}}
              />
              <Button
                onClick={() => onButtonOneClick()}
                label={t('layout.remove')}
                type="error"
                style={{width: '115px'}}
              />
            </>
          )}
        </div>
      </div>
      <div className="container py-10 h-64 px-8">
        <div className="w-full h-full rounded">{children}</div>
      </div>
    </>
  );
};

export default ContentWrapper;
